<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div class="d-flex justify--space-between">
          <h1>Поводы</h1>
          <va-button color="info" @click="openCreateModal">
            Добавить повод
          </va-button>
        </div>
      </va-card>
      <reasons-table class="mb-4" :reasons="getReasons"></reasons-table>
      <va-modal v-model="showCreateForm" size="large" hide-default-actions>
        <create-reason @hide="hideModal"></create-reason>
      </va-modal>
    </va-inner-loading>
  </div>
</template>

<script>
import ReasonsTable from "../../components/reasons/reasons-table.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import CreateReason from "../../components/reasons/create-reason.vue";
export default {
  components: { ReasonsTable, CreateReason },
  data() {
    return {
      showCreateForm: false,
    };
  },
  async created() {
    await this.getReasonsActions();
  },
  computed: {
    ...mapState("reason", ["reasons"]),
    ...mapGetters({
      loader: "isLoading",
    }),
    getReasons() {
      return this.reasons;
    },
  },
  methods: {
    ...mapActions({
      getReasonsActions: "reason/getReasons",
    }),
    hideModal() {
      this.showCreateForm = false;
    },
    openCreateModal() {
      this.showCreateForm = !this.showCreateForm;
    },
  },
};
</script>

<style></style>
